import Vue from 'vue'

import 'vue-datetime/dist/vue-datetime.css'
import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'
import VueApexCharts from 'vue-apexcharts'
import Vue2Editor from 'vue2-editor'
import VueNumeric from 'vue-numeric'

/* Functions - Funções Global do Sistema */
import FccFunctions from './components/mixins/functions.js'
/* Functions - Funções Datas do Sistema */
import FccDatas from './components/mixins/datas.js'
/* Functions - Funções Datas do Sistema */
import Emuladores from './components/mixins/emuladores.js'

import FccUsuarios from './components/mixins/fccUsuarios.js'

import FccCondicaoEspecial from './components/mixins/condicaoEspecifica.js'

/* FCC Base */
import 'pkgfe.fccbase'

Vue.component('datetime', Datetime)
Vue.use(Vue2Editor)

Settings.defaultLocale = 'pt-BR'
Settings.defaultZoneName = 'America/Sao_Paulo'
Vue.component('apexchart', VueApexCharts)

/* Use */
Vue.use(VueNumeric)

/* Mixins */
Vue.mixin(FccDatas)
Vue.mixin(FccFunctions)
Vue.mixin(Emuladores)
Vue.mixin(FccUsuarios)
Vue.mixin(FccCondicaoEspecial)
